import React, { useState } from 'react';
import { login } from '../../Services/Api.service';
import { translate } from '../../../Services/translation';

export const LoginPage = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onSubmit = (e) => {
        e.preventDefault();
        login(email, password, props.redirectUrl);
    };

    return (
        <div className="backend__login">
            <h1 className="backend__login-title">{translate('coptikk.adminportal.login.title')}</h1>
            <form className="backend__login-form" onSubmit={(e) => onSubmit(e)}>
                <div className="row">
                    <div className="columns small-12">
                        <input tabIndex={1} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={translate('coptikk.adminportal.login.placeholder.email')} />
                    </div>
                    <div className="columns small-12">
                        <input tabIndex={2} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={translate('coptikk.adminportal.login.placeholder.password')}/>
                    </div>
                    <div className="columns small-12">
                        <button tabIndex={3} type='submit' className="button">{translate('coptikk.adminportal.login.buttontext')}</button>
                    </div>
                </div>
            </form>
        </div>
    );
}